import { apiFetch } from '../../systems/api-client';
import { getEditorSettings } from '../../systems/editor-settings';
import type { AiBlockContext, AiBlockType, GenerateBlockResponse } from './ai-block-guides';

export async function generateAiBlock(
  blockType: AiBlockType,
  prompt: string,
  context?: AiBlockContext
): Promise<GenerateBlockResponse> {
  const settings = getEditorSettings();
  const body: Record<string, unknown> = { blockType, prompt, context };

  if (settings.anthropicApiKey.trim()) {
    body.apiKey = settings.anthropicApiKey.trim();
  }
  if (settings.anthropicModel?.trim()) {
    body.model = settings.anthropicModel.trim();
  }

  const response = await apiFetch('/api/editor/generate-block', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  const data = await response.json();
  if (!response.ok) {
    const details =
      Array.isArray(data.zodIssues) && data.zodIssues.length
        ? `\n${data.zodIssues.map((i: { path: string; message: string }) => `• ${i.path}: ${i.message}`).join('\n')}`
        : '';
    throw new Error((data.error || 'Échec de génération') + details);
  }

  return data as GenerateBlockResponse;
}
